// extracted by mini-css-extract-plugin
export default {"listArticleContainer":"ListArticle_listArticleContainer__0mD1C"};